import React from "react";
import "./Dashboard.css";
import {Container, Row} from "react-bootstrap";
import LiveChat from 'react-livechat';
import {mygaSession} from "../../scripts/myga-session";
import AppPageHeader from "../Application/AppPageHeader/AppPageHeader";

class CDRateList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {rates: [], effectiveDate: ''};
  }

  componentDidMount() {
    let rates = mygaSession.getBankRates();
    let effectiveDate = rates.effectiveDate;
    rates.cdRates = rates.cdRates.map(item => {
      item.rates = item.rates.map(rate => {
        let rateNum = parseInt(rate.duration.split(' ')[0]);
        rate.duration = rate.duration.replace('m', ' Months');
        rate.duration = rate.duration.replace('y', (rateNum > 1) ? ' Years' : ' Year');
        rate.rate = parseFloat(rate.rate).toFixed(2) + '%';
        return rate;
      });

      return {
        ...item,
        effectiveDate
      }
    });
    this.setState({rates: rates.cdRates});
  };

  headerStyles = {
    fontSize: '.7em',
    backgroundColor: 'var(--HeaderBackgroundYellow)'
  };

  renderRow = data => {
    let renderRates = rate => {
      return (
        <Container style={{display: 'flex', justifyContent: 'flex-end', marginRight: '1em', textAlign: 'right'}}>
          <div className={'col-6'}>{rate.duration}</div>
          <div className={'col-3 col-sm-2'}>{rate.rate}</div>
        </Container>
      )
    };
    return (
      <Row>
        <Container className={'p-0'}>
          <div className={'rate-list-header'} style={{display: 'flex', justifyContent: 'space-between'}}>
            <div>
              <div>{data.institution}</div>
              <div style={{fontSize: '.8em', paddingLeft: '1em'}}><i>{data.account}</i></div>
            </div>
            <div className={'text-center'}>
              <div style={{fontSize: '.8em', whiteSpace: 'nowrap'}}>Minimum Deposit</div>
              <div>${data.minimum}</div>
            </div>
          </div>

          {data.rates.map(renderRates)}
        </Container>

      </Row>
    )
  };

  title = 'Bank CD Rates';
  render() {

    return (


      <Container className="page-area noselect">
        <div className={'page-content-area'}>
        <AppPageHeader fullPage headerLabel={this.title} updatePage={this.props.updatePage}/>
        <Container className={'p-0'} style={{overflowY: 'auto'}}>
          <div style={{paddingTop: '1em'}}/>
          {this.state.rates.map(item => (this.renderRow(item)))}
          <div style={{marginBottom: '2em'}}/>
        </Container>
          </div>
        <LiveChat license={11222357} group={2}/>
      </Container>


    );

  }
}

export default CDRateList;